var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "content",
    },
    [
      _c("div", { staticClass: "header" }, [
        _c(
          "div",
          { staticClass: "tab" },
          _vm._l(_vm.tabList, function (item, $index) {
            return _c(
              "span",
              {
                key: $index,
                class: [
                  "tabItem",
                  _vm.active === item.type.value ? "active" : "",
                ],
                on: {
                  click: function ($event) {
                    return _vm.changeType(item.type.value)
                  },
                },
              },
              [
                _vm._v(
                  " " + _vm._s(item.type.label) + "(" + _vm._s(item.qty) + ") "
                ),
              ]
            )
          }),
          0
        ),
        _c(
          "div",
          { staticClass: "header-opt" },
          [
            _c(
              "div",
              { staticClass: "search" },
              [
                _c("el-input", {
                  staticClass: "input-search",
                  attrs: {
                    placeholder: "请输入进口商名称\\EIN NO",
                    clearable: "",
                  },
                  on: { clear: _vm.initList },
                  nativeOn: {
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.initList.apply(null, arguments)
                    },
                  },
                  model: {
                    value: _vm.searchVal,
                    callback: function ($$v) {
                      _vm.searchVal = $$v
                    },
                    expression: "searchVal",
                  },
                }),
                _c(
                  "div",
                  { staticClass: "btn-search", on: { click: _vm.initList } },
                  [_c("i", { staticClass: "el-icon-search" })]
                ),
              ],
              1
            ),
            _c("div", { staticClass: "filter-tab" }, [
              _c(
                "span",
                {
                  class: [
                    "tab-item",
                    "flex_c_c",
                    _vm.filterList.isAssigned === "" && "active",
                  ],
                  on: {
                    click: function ($event) {
                      return _vm.changeIsAssigned("")
                    },
                  },
                },
                [_vm._v("全部")]
              ),
              _c(
                "span",
                {
                  class: [
                    "tab-item",
                    "flex_c_c",
                    _vm.filterList.isAssigned && "active",
                  ],
                  on: {
                    click: function ($event) {
                      return _vm.changeIsAssigned(true)
                    },
                  },
                },
                [_vm._v("已分配供应商")]
              ),
              _c(
                "span",
                {
                  class: [
                    "tab-item",
                    "flex_c_c",
                    _vm.filterList.isAssigned === false && "active",
                  ],
                  on: {
                    click: function ($event) {
                      return _vm.changeIsAssigned(false)
                    },
                  },
                },
                [_vm._v("未分配供应商")]
              ),
            ]),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "permissson",
                    rawName: "v-permissson",
                    value: "add",
                    expression: "'add'",
                  },
                ],
                staticClass: "add flex_c_c",
                on: {
                  click: function ($event) {
                    _vm.dialogVisible1 = true
                  },
                },
              },
              [
                _c("i", { staticClass: "el-icon-circle-plus-outline" }),
                _vm._v("新增 "),
              ]
            ),
            _c(
              "BaseFilter",
              {
                attrs: { isActive: _vm.isActive, width: 780 },
                on: {
                  sendFilter: _vm.sendFilter,
                  reset: _vm.reset,
                  exportData: _vm.exportData,
                },
              },
              [
                _c(
                  "el-form",
                  {
                    ref: "form",
                    attrs: { model: _vm.filterList, "label-width": "112px" },
                  },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 10 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "状态" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: "请选择",
                                      clearable: "",
                                      "collapse-tags": "",
                                      multiple: "",
                                    },
                                    model: {
                                      value: _vm.filterList.status,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.filterList, "status", $$v)
                                      },
                                      expression: "filterList.status",
                                    },
                                  },
                                  _vm._l(
                                    _vm.config.importerStatusOptions,
                                    function (item) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "归属" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: "请选择",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.filterList.belong,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.filterList, "belong", $$v)
                                      },
                                      expression: "filterList.belong",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "内部", value: 0 },
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "外部", value: 1 },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "公司" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: "请选择",
                                      filterable: "",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.filterList.companyIds,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.filterList,
                                          "companyIds",
                                          $$v
                                        )
                                      },
                                      expression: "filterList.companyIds",
                                    },
                                  },
                                  _vm._l(_vm.companyDrapdown, function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "注册时间" } },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    type: "daterange",
                                    "range-separator": "-",
                                    align: "center",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期",
                                    "value-format": "yyyy-MM-dd",
                                  },
                                  model: {
                                    value: _vm.filterList.registerDate,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.filterList,
                                        "registerDate",
                                        $$v
                                      )
                                    },
                                    expression: "filterList.registerDate",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "生效日期" } },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    type: "daterange",
                                    "range-separator": "-",
                                    align: "center",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期",
                                    "value-format": "yyyy-MM-dd",
                                  },
                                  model: {
                                    value: _vm.filterList.effectiveDate,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.filterList,
                                        "effectiveDate",
                                        $$v
                                      )
                                    },
                                    expression: "filterList.effectiveDate",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "截止日期" } },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    type: "daterange",
                                    "range-separator": "-",
                                    align: "center",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期",
                                    "value-format": "yyyy-MM-dd",
                                  },
                                  model: {
                                    value: _vm.filterList.closeDate,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.filterList, "closeDate", $$v)
                                    },
                                    expression: "filterList.closeDate",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "创建时间" } },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    type: "daterange",
                                    "range-separator": "-",
                                    align: "center",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期",
                                    "value-format": "yyyy-MM-dd",
                                  },
                                  model: {
                                    value: _vm.filterList.createdOn,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.filterList, "createdOn", $$v)
                                    },
                                    expression: "filterList.createdOn",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "报税截止时间" } },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    type: "daterange",
                                    "range-separator": "-",
                                    align: "center",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期",
                                    "value-format": "yyyy-MM-dd",
                                  },
                                  model: {
                                    value: _vm.filterList.bondedDeadlineDate,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.filterList,
                                        "bondedDeadlineDate",
                                        $$v
                                      )
                                    },
                                    expression: "filterList.bondedDeadlineDate",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "年审截止时间" } },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    type: "daterange",
                                    "range-separator": "-",
                                    align: "center",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期",
                                    "value-format": "yyyy-MM-dd",
                                  },
                                  model: {
                                    value: _vm.filterList.yearAuditDeadlineDate,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.filterList,
                                        "yearAuditDeadlineDate",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "filterList.yearAuditDeadlineDate",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "BOI是否" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: "请选择",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.filterList.isBOI,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.filterList, "isBOI", $$v)
                                      },
                                      expression: "filterList.isBOI",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "是", value: true },
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "否", value: false },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "月结是否" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: "请选择",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.filterList.isMonthEnd,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.filterList,
                                          "isMonthEnd",
                                          $$v
                                        )
                                      },
                                      expression: "filterList.isMonthEnd",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "是", value: true },
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "否", value: false },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "是否禁用" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: "请选择",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.filterList.isActived,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.filterList,
                                          "isActived",
                                          $$v
                                        )
                                      },
                                      expression: "filterList.isActived",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "是", value: true },
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "否", value: false },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "敏感进口商" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: "请选择",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.filterList.isSensitiveImporter,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.filterList,
                                          "isSensitiveImporter",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "filterList.isSensitiveImporter",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "是", value: true },
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "否", value: false },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "是否注销" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: "请选择",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.filterList.isCancel,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.filterList,
                                          "isCancel",
                                          $$v
                                        )
                                      },
                                      expression: "filterList.isCancel",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "是", value: true },
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "否", value: false },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "Surety Code" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      filterable: "",
                                      clearable: "",
                                      placeholder: "请选择",
                                    },
                                    model: {
                                      value: _vm.filterList.suretyCode,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.filterList,
                                          "suretyCode",
                                          $$v
                                        )
                                      },
                                      expression: "filterList.suretyCode",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "054", value: "054" },
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "856", value: "856" },
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "036", value: "036" },
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "300", value: "300" },
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "846", value: "846" },
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "873", value: "873" },
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "128", value: "128" },
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "664", value: "664" },
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "353", value: "353" },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "买BOND代理" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: "请选择",
                                      filterable: "",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.filterList.bondSupplierId,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.filterList,
                                          "bondSupplierId",
                                          $$v
                                        )
                                      },
                                      expression: "filterList.bondSupplierId",
                                    },
                                  },
                                  _vm._l(_vm.supplierOptions, function (item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label: item.code + "-" + item.wbName,
                                        value: item.id,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "EIN号码" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: { placeholder: "请输入EIN" },
                                  model: {
                                    value: _vm.filterList.taxNo,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.filterList, "taxNo", $$v)
                                    },
                                    expression: "filterList.taxNo",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "法人" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder:
                                      "请输入法人名称，多个用分号隔开 多个查询必须精确 单个可以模糊",
                                  },
                                  model: {
                                    value: _vm.contactsInput,
                                    callback: function ($$v) {
                                      _vm.contactsInput = $$v
                                    },
                                    expression: "contactsInput",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "data" },
        [
          _vm.height
            ? _c("BaseTable", {
                attrs: {
                  height: _vm.height,
                  tableData: {
                    ..._vm.tableData,
                    fileds: _vm.fileds,
                  },
                  pageIndex: _vm.pager.pageIndex,
                  pageSize: _vm.pager.pageSize,
                  border: true,
                },
                on: {
                  handlePageChange: _vm.handlePageChange,
                  handleSelectionChange: _vm.handleSelectionChange,
                  sortChange: _vm.sortChange,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "status",
                      fn: function (row) {
                        return _c(
                          "span",
                          {
                            class: [
                              "status",
                              `status${row.scope.status}`,
                              "flex_c_c",
                            ],
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.formatStatus(row.scope)) + " "
                            ),
                          ]
                        )
                      },
                    },
                    {
                      key: "belong",
                      fn: function (row) {
                        return [
                          _c(
                            "span",
                            {
                              class: [
                                "belong",
                                `belong${row.scope.belong}`,
                                "flex_c_c",
                              ],
                            },
                            [_vm._v(" " + _vm._s(row.scope.belongName) + " ")]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "margin-top": "6px",
                                color: "#423169",
                              },
                            },
                            [
                              _vm._v(
                                " 客户数(" +
                                  _vm._s(row.scope.companyNumber) +
                                  ") "
                              ),
                              _c("i", {
                                staticClass: "el-icon-edit-outline",
                                staticStyle: {
                                  cursor: "pointer",
                                  color: "#67C23A",
                                  "margin-left": "4px",
                                },
                                attrs: { title: "分配客户" },
                                on: {
                                  click: function ($event) {
                                    return _vm.companyRow(row.scope, false)
                                  },
                                },
                              }),
                            ]
                          ),
                          row.scope.companyNumber <= 3
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    "margin-top": "6px",
                                    color: "#666666",
                                  },
                                },
                                _vm._l(
                                  row.scope.companyNames,
                                  function (item, index) {
                                    return _c("div", { key: index }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            typeof item === "string" ? item : ""
                                          ) +
                                          " "
                                      ),
                                    ])
                                  }
                                ),
                                0
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: "countryName",
                      fn: function (row) {
                        return [
                          _c("div", { staticClass: "address-row" }, [
                            _c("div", { staticClass: "mark-item" }, [
                              _c(
                                "span",
                                { staticClass: "label label5 flex_c_c" },
                                [_vm._v("国家")]
                              ),
                              _c("span", { staticClass: "value" }, [
                                _vm._v(_vm._s(row.scope.countryName)),
                              ]),
                            ]),
                            _c("div", { staticClass: "mark-item" }, [
                              _c(
                                "span",
                                { staticClass: "label label5 flex_c_c" },
                                [_vm._v("省州")]
                              ),
                              _c("span", { staticClass: "value" }, [
                                _vm._v(_vm._s(row.scope.provinceEnName)),
                              ]),
                            ]),
                            _c("div", { staticClass: "mark-item" }, [
                              _c(
                                "span",
                                { staticClass: "label label5 flex_c_c" },
                                [_vm._v("城市")]
                              ),
                              _c("span", { staticClass: "value" }, [
                                _vm._v(_vm._s(row.scope.cityAddress)),
                              ]),
                            ]),
                            _c("div", { staticClass: "mark-item" }, [
                              _c(
                                "span",
                                { staticClass: "label label5 flex_c_c" },
                                [_vm._v("邮编")]
                              ),
                              _c("span", { staticClass: "value" }, [
                                _vm._v(_vm._s(row.scope.postcode || "--")),
                              ]),
                            ]),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "mark-item",
                              staticStyle: { "margin-top": "12px" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "label label5 flex_c_c" },
                                [_vm._v("地址")]
                              ),
                              _c("span", { staticClass: "value" }, [
                                _vm._v(_vm._s(row.scope.address)),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "createdOn",
                      fn: function (row) {
                        return [
                          _c("div", { staticClass: "mark-item" }, [
                            _c(
                              "span",
                              { staticClass: "label label6 flex_c_c" },
                              [_vm._v("创建人")]
                            ),
                            _c("span", { staticClass: "value" }, [
                              _vm._v(_vm._s(row.scope.createdName)),
                            ]),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "mark-item",
                              staticStyle: { "margin-top": "12px" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "label label6 flex_c_c" },
                                [_vm._v("创建时间")]
                              ),
                              _c("span", { staticClass: "value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatDate")(row.scope.createdOn)
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "isBOI",
                      fn: function (row) {
                        return _c(
                          "span",
                          {
                            key: row.scope.isBOI,
                            style: { color: row.scope.isBOI ? "" : "#FE453D" },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(row.scope.isBOI ? "是" : "否") + " "
                            ),
                          ]
                        )
                      },
                    },
                    {
                      key: "isMonthEnd",
                      fn: function (row) {
                        return _c(
                          "span",
                          {
                            key: row.scope.isMonthEnd,
                            style: {
                              color: row.scope.isMonthEnd ? "" : "#FE453D",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(row.scope.isMonthEnd ? "是" : "否") +
                                " "
                            ),
                          ]
                        )
                      },
                    },
                    {
                      key: "isSensitiveImporter",
                      fn: function (row) {
                        return _c(
                          "span",
                          {
                            key: row.scope.isSensitiveImporter,
                            style: {
                              color: row.scope.isSensitiveImporter
                                ? ""
                                : "#FE453D",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  row.scope.isSensitiveImporter ? "是" : "否"
                                ) +
                                " "
                            ),
                          ]
                        )
                      },
                    },
                    {
                      key: "usedBondAmount",
                      fn: function (row) {
                        return [
                          _c("div", { staticClass: "mark-item" }, [
                            _c(
                              "span",
                              { staticClass: "label label6 flex_c_c" },
                              [_vm._v("总额度")]
                            ),
                            _c("span", { staticClass: "value" }, [
                              _vm._v(_vm._s(row.scope.bondTotal || "--")),
                            ]),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "mark-item",
                              staticStyle: { "margin-top": "12px" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "label label6 flex_c_c" },
                                [_vm._v("已使用")]
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "value",
                                  style: {
                                    color:
                                      row.scope.usedBondAmount >
                                      row.scope.bondTotal
                                        ? "#FE453D"
                                        : "",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(row.scope.usedBondAmount || "--")
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "mark-item",
                              staticStyle: { "margin-top": "12px" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "label label6 flex_c_c" },
                                [_vm._v("未使用")]
                              ),
                              _c("span", { staticClass: "value" }, [
                                _vm._v(
                                  _vm._s(row.scope.remainingAmount || "--")
                                ),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "inTransitMbl",
                      fn: function (row) {
                        return [
                          _vm._v(" " + _vm._s(row.scope.inTransitMbl) + " "),
                          row.scope.inTransitMbl
                            ? _c("img", {
                                staticStyle: { "margin-top": "5px" },
                                attrs: {
                                  src: require("@/assets/images/bill/tax-detail.png"),
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.dialogVisible10 = true
                                    _vm.rowData = row.scope
                                  },
                                },
                              })
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: "importerDeclare",
                      fn: function (row) {
                        return [
                          _vm._v(" " + _vm._s(row.scope.importerDeclare) + " "),
                          row.scope.importerDeclare
                            ? _c("img", {
                                staticStyle: { "margin-top": "5px" },
                                attrs: {
                                  src: require("@/assets/images/bill/tax-detail.png"),
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.dialogVisible11 = true
                                    _vm.rowData = row.scope
                                  },
                                },
                              })
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: "bondNumber",
                      fn: function (row) {
                        return [
                          _c("div", { staticClass: "mark-item" }, [
                            _c(
                              "span",
                              { staticClass: "label label10 flex_c_c" },
                              [_vm._v("BOND Number")]
                            ),
                            _c("span", { staticClass: "value" }, [
                              _vm._v(_vm._s(row.scope.bondNumber || "--")),
                            ]),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "mark-item",
                              staticStyle: { "margin-top": "4px" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "label label10 flex_c_c" },
                                [_vm._v("Surety Code")]
                              ),
                              _c("span", { staticClass: "value" }, [
                                _vm._v(_vm._s(row.scope.suretyCode || "--")),
                              ]),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "mark-item",
                              staticStyle: { "margin-top": "4px" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "label label10 flex_c_c" },
                                [_vm._v("买BOND代理")]
                              ),
                              _c("span", { staticClass: "value" }, [
                                _vm._v(
                                  _vm._s(row.scope.bondSupplierCode || "--")
                                ),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "mblSeaTotal",
                      fn: function (row) {
                        return [
                          _c("div", { staticClass: "mark-item" }, [
                            _c(
                              "span",
                              { staticClass: "label label5 flex_c_c" },
                              [_vm._v("海运")]
                            ),
                            _c("span", { staticClass: "value" }, [
                              _vm._v(_vm._s(row.scope.mblSeaTotal)),
                            ]),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "mark-item",
                              staticStyle: { "margin-top": "4px" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "label label5 flex_c_c" },
                                [_vm._v("空运")]
                              ),
                              _c("span", { staticClass: "value" }, [
                                _vm._v(_vm._s(row.scope.mblAirTotal)),
                              ]),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "mark-item",
                              staticStyle: { "margin-top": "4px" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "label label5 flex_c_c" },
                                [_vm._v("查验")]
                              ),
                              _c("span", { staticClass: "value" }, [
                                _vm._v(_vm._s(row.scope.holdTotal)),
                              ]),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "mark-item",
                              staticStyle: { "margin-top": "4px" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "label label5 flex_c_c" },
                                [_vm._v("放行")]
                              ),
                              _c("span", { staticClass: "value" }, [
                                _vm._v(_vm._s(row.scope.releaseTotal)),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "cancelDate",
                      fn: function (row) {
                        return [
                          _c("div", { staticClass: "mark-item" }, [
                            _c(
                              "span",
                              { staticClass: "label label6 flex_c_c" },
                              [_vm._v("是否注销")]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "value",
                                style: `color: ${
                                  row.scope.isCancel ? "#FE453D" : ""
                                }`,
                              },
                              [_vm._v(_vm._s(row.scope.isCancel ? "是" : "否"))]
                            ),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "mark-item",
                              staticStyle: { "margin-top": "12px" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "label label6 flex_c_c" },
                                [_vm._v("注销时间")]
                              ),
                              _c("span", { staticClass: "value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatDate")(row.scope.cancelDate)
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "yearAuditDeadlineDate",
                      fn: function (row) {
                        return [
                          _c("div", { staticClass: "mark-item" }, [
                            _c(
                              "span",
                              { staticClass: "label label9 flex_c_c" },
                              [_vm._v("报税截止时间")]
                            ),
                            _c("span", { staticClass: "value" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("formatDate")(
                                    row.scope.bondedDeadlineDate
                                  )
                                )
                              ),
                            ]),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "mark-item",
                              staticStyle: { "margin-top": "12px" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "label label9 flex_c_c" },
                                [_vm._v("年审截止时间")]
                              ),
                              _c("span", { staticClass: "value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatDate")(
                                      row.scope.yearAuditDeadlineDate
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "fileNumber",
                      fn: function (row) {
                        return [
                          _vm._v(" " + _vm._s(row.scope.fileNumber) + " "),
                          _c(
                            "span",
                            {
                              staticClass: "check_btn",
                              on: {
                                click: function ($event) {
                                  return _vm.checkFile(row.scope)
                                },
                              },
                            },
                            [_vm._v("查看")]
                          ),
                        ]
                      },
                    },
                    {
                      key: "companyNumber",
                      fn: function (row) {
                        return [
                          _vm._v(" " + _vm._s(row.scope.companyNumber) + " "),
                          row.scope.companyNumber > 0
                            ? _c(
                                "span",
                                {
                                  staticClass: "check_btn",
                                  on: {
                                    click: function ($event) {
                                      return _vm.companyRow(row.scope, true)
                                    },
                                  },
                                },
                                [_vm._v("查看")]
                              )
                            : _vm._e(),
                          row.scope.companyNumber > 0
                            ? _c(
                                "span",
                                {
                                  staticClass: "export_btn",
                                  attrs: { loading: _vm.exportloading },
                                  on: {
                                    click: function ($event) {
                                      return _vm.exportImporterCompany(
                                        row.scope
                                      )
                                    },
                                  },
                                },
                                [_vm._v("导出")]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: "supplierData",
                      fn: function (row) {
                        return [
                          _c("div", { staticClass: "mark-item" }, [
                            _c(
                              "span",
                              { staticClass: "label label6 flex_c_c" },
                              [_vm._v("电话")]
                            ),
                            _c("span", { staticClass: "value" }, [
                              _vm._v(
                                _vm._s(
                                  row.scope?.supplierData?.phoneNumber || "--"
                                )
                              ),
                            ]),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "mark-item",
                              staticStyle: { "margin-top": "12px" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "label label6 flex_c_c" },
                                [_vm._v("邮箱")]
                              ),
                              _c("span", { staticClass: "value" }, [
                                _vm._v(
                                  _vm._s(row.scope?.supplierData?.email || "--")
                                ),
                              ]),
                              row.scope?.supplierData?.email
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "check_btn",
                                      staticStyle: { "margin-left": "6px" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.checkEmailPassDialog(
                                            row.scope
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("邮箱密码")]
                                  )
                                : _vm._e(),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "mark-item",
                              staticStyle: { "margin-top": "12px" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "label label6 flex_c_c" },
                                [_vm._v("备注")]
                              ),
                              _c("span", { staticClass: "value" }, [
                                _vm._v(
                                  _vm._s(
                                    row.scope?.supplierData?.remark || "--"
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "supplierNames",
                      fn: function (row) {
                        return _vm._l(
                          row.scope.supplierNames,
                          function (item, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "supplierNames" },
                              [_vm._v(" " + _vm._s(item) + " ")]
                            )
                          }
                        )
                      },
                    },
                    {
                      key: "userGroupName",
                      fn: function (row) {
                        return [
                          row.scope?.userGroupName != null &&
                          row.scope?.userGroupName != ""
                            ? _c("span", { staticClass: "group-item" }, [
                                _vm._v(
                                  " " + _vm._s(row.scope?.userGroupName) + " "
                                ),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: "opt",
                      fn: function (row) {
                        return _c(
                          "div",
                          { staticClass: "tableOpt" },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.editRow(row.scope)
                                  },
                                },
                              },
                              [_vm._v("修改")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDelete(row.scope)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.supplierRow(row.scope)
                                  },
                                },
                              },
                              [_vm._v("分供应商")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.companyRow(row.scope, false)
                                  },
                                },
                              },
                              [_vm._v("分配客户")]
                            ),
                          ],
                          1
                        )
                      },
                    },
                    {
                      key: "custom-total",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            { staticClass: "custom-total" },
                            [
                              _c("div", { staticClass: "select" }, [
                                _vm._v(" 已选 "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.selectionItem.length)),
                                ]),
                                _vm._v(" 项 "),
                              ]),
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    placement: "bottom",
                                    "popper-class": "popper_tooltip",
                                    trigger: "click",
                                    "visible-arrow": false,
                                  },
                                },
                                [
                                  _c("div", { staticClass: "btn-list" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "flex_c_c",
                                        on: {
                                          click: function ($event) {
                                            return _vm.batchUpdate(0)
                                          },
                                        },
                                      },
                                      [_vm._v("更新BOND信息")]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "flex_c_c",
                                        on: {
                                          click: function ($event) {
                                            return _vm.batchUpdate(1)
                                          },
                                        },
                                      },
                                      [_vm._v("更新状态")]
                                    ),
                                    _vm.active !== null
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "flex_c_c",
                                            on: {
                                              click: function ($event) {
                                                return _vm.batchUpdate(2)
                                              },
                                            },
                                          },
                                          [_vm._v(" 更新邮箱密码 ")]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "flex_c_c",
                                        on: {
                                          click: function ($event) {
                                            return _vm.batchUpdate(3)
                                          },
                                        },
                                      },
                                      [_vm._v("更新其它信息")]
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "batch-btn flex_c_c",
                                      attrs: { slot: "reference" },
                                      slot: "reference",
                                    },
                                    [
                                      _vm._v(" 批量更新"),
                                      _c("img", {
                                        attrs: {
                                          src: require("@/assets/images/batch-arrow.png"),
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  staticClass: "export-btn flex_c_c",
                                  attrs: { slot: "reference" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.selectexport()
                                    },
                                  },
                                  slot: "reference",
                                },
                                [_vm._v("导 出")]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  3539461287
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _c("AddImporterDialog", {
        attrs: {
          dialogVisible: _vm.dialogVisible1,
          rowData: _vm.rowData,
          companyOptions: _vm.companyDrapdown,
          userGroupOptions: _vm.userGroupOptions,
          supplierOptions: _vm.supplierOptions,
        },
        on: { cancel: _vm.cancel, ok: _vm.ok },
      }),
      _c("UpdateBondInfoDialog", {
        attrs: {
          dialogVisible: _vm.dialogVisible2,
          selectionItem: _vm.selectionItem,
          supplierOptions: _vm.supplierOptions,
        },
        on: { cancel: _vm.cancel, ok: _vm.ok },
      }),
      _c("UpdateStatusDialog", {
        attrs: {
          dialogVisible: _vm.dialogVisible3,
          selectionItem: _vm.selectionItem,
        },
        on: { cancel: _vm.cancel, ok: _vm.ok },
      }),
      _c("UpdateEmailPassDialog", {
        attrs: {
          dialogVisible: _vm.dialogVisible4,
          selectionItem: _vm.selectionItem,
          supplierId: _vm.active,
        },
        on: { cancel: _vm.cancel, ok: _vm.ok },
      }),
      _c("UpadteOtherInfoDialog", {
        attrs: {
          dialogVisible: _vm.dialogVisible5,
          selectionItem: _vm.selectionItem,
        },
        on: { cancel: _vm.cancel, ok: _vm.ok },
      }),
      _c("CheckFileDialog", {
        attrs: { dialogVisible: _vm.dialogVisible6, rowData: _vm.rowData },
        on: { cancel: _vm.cancel },
      }),
      _c("AllocationSupplierDialog", {
        attrs: { dialogVisible: _vm.dialogVisible7, rowData: _vm.rowData },
        on: { cancel: _vm.cancel, ok: _vm.ok },
      }),
      _c("OperationLogDrawer", {
        attrs: { drawer: _vm.drawer1, rowData: _vm.rowData },
        on: {
          close: function ($event) {
            _vm.drawer1 = false
          },
        },
      }),
      _c("AllocationCompanyDialog", {
        attrs: {
          dialogVisible: _vm.dialogVisible8,
          rowData: _vm.rowData,
          companyOptions: _vm.companyDrapdown,
          isCheckCompany: _vm.isCheckCompany,
        },
        on: { cancel: _vm.cancel, ok: _vm.ok },
      }),
      _c("CheckEmailPassDialog", {
        attrs: { dialogVisible: _vm.dialogVisible9, rowData: _vm.rowData },
        on: { cancel: _vm.cancel },
      }),
      _c("OnLineBillDialog", {
        attrs: { dialogVisible: _vm.dialogVisible10, rowData: _vm.rowData },
        on: {
          cancel: function ($event) {
            _vm.dialogVisible10 = false
          },
        },
      }),
      _c("DeclareHistoryDialog", {
        attrs: { dialogVisible: _vm.dialogVisible11, rowData: _vm.rowData },
        on: {
          cancel: function ($event) {
            _vm.dialogVisible11 = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }